export default {"src":"/_next/static/media/file-modul-proyek.22076504.svg","height":14,"width":14};